<template>
    <b-container>
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Tickets de Soporte</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" md="3" class="mt-4 mb-2">
                <b-button variant="default" pill block size="sm" @click="clearData" v-b-modal.ticket>
                    <i class="material-icons mdi mdi-comment-plus"></i>&nbsp;
                    <span>Crear Ticket</span>
                </b-button>
            </b-col>
            <b-col cols="12" md="9" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay tickets que coincidan con la búsqueda"
                    empty-text="No tienes tickets creados"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(actions)="row">
                        <b-button variant="primary" size="sm" title="Ver Detalles" :to="'support/'+row.item.id+'/details'">
                            <i class="material-icons">visibility</i>
                        </b-button>
                        <b-button variant="danger" size="sm" title="Cerrar Ticket" @click="close(row.item.id)" :disabled="row.item.status === 303">
                            <i class="material-icons">cancel</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Add/Edit Account -->
                <b-modal
                    id="ticket"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    title="Crear Ticket"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <b-form id="formTicket" @submit.stop.prevent="create()">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.reason+':'">
                                    <b-form-input
                                        name="reason"
                                        v-model="form.reason"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|max:255'"
                                        :state="validateState('reason')"
                                        :data-vv-as="(labels.reason).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="reason-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="reason-live-feedback">{{
                                            veeErrors.first('reason')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.payment+':'">
                                    <b-form-input
                                        name="payment"
                                        v-model="form.payment"
                                        type="text"
                                        inputmode="numeric"
                                        class="text-center"
                                        v-validate="'required:true|numeric'"
                                        :state="validateState('payment')"
                                        :data-vv-as="(labels.payment).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="payment-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="payment-live-feedback">{{
                                            veeErrors.first('payment')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.description+':'">
                                    <b-form-textarea
                                        name="description"
                                        :value="form.description"
                                        v-model="form.description"
                                        class="form-control"
                                        no-resize
                                        rows="6"
                                        placeholder="Por favor describe claramente tu situación..."
                                        v-validate="'required:true|min:20'"
                                        :state="validateState('description')"
                                        :data-vv-as="(labels.description).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="description-live-feedback"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback id="description-live-feedback">{{
                                            veeErrors.first('description')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="shadow align-middle px-5"
                                          form="formTicket" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? 'Creando...' : 'Crear' }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Support",
    props: [ 'user' ],
    data: () => ({
        id: 0,
        labels: {
            payment: 'Código de Pago',
            reason: 'Motivo',
            description: 'Descripción'
        },
        form: {
            payment: null,
            reason: null,
            description: null
        },
        loading: false,
        isBusy: true,
        search: '',
        fields: [
            { key: 'id', label: 'Ticket #', sortable: true },
            { key: 'reason', label: 'Motivo', sortable: true },
            { key: 'status_name', label: 'Estado', sortable: true },
            { key: 'actions', label: 'Acción', sortable: false }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }]
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'supportpage');
        this.getData();
    },
    methods: {
        getData() {
            axios.get('/api/customer/tickets').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.tickets;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
        },
        clearData(id) {
            this.form = {
                id: null,
                reason: null,
                description: null
            };
            if (id) {
                this.id = id;
                const items = this.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.form = items[i];
                    }
                }
            } else {
                this.id = 0;
            }
        },
        create() {
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.loading = true;
                axios.post('/api/customer/tickets/add', this.form).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getData();
                        this.$bvModal.hide('ticket');
                        this.clearData();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        close(id) {
            this.$swal({
                title: '¿Estas seguro de cerrar este ticket?',
                text: 'Ticket #' + id,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, cerrar',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'No, dejar abierto',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.id = id;

                    let formData = new FormData();
                    formData.append('id', id);

                    axios.post('/api/customer/tickets/close', formData).then(res => {
                        if (res.data.status === 'success') {
                            this.getData();
                            this.clearData();
                        }
                        this.$root.$bvToast.toast(res.data.msg, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: res.data.status,
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        }
    }
}
</script>

<style scoped>
.form-control {
    border-radius: 10px;
}
</style>
